{
  "allianz": {
    "checkInBanner": {
      "href": ""
    },
    "first24hBanner": {
      "href": ""
    },
    "purchaseSuccessBanner": {
      "href": ""
    },
    "from24hTo48hBanner": {
      "href": ""
    },
    "after48hBanner": {
      "href": ""
    },
    "travelInsurancePage": {
      "ctaButtonHref": ""
    }
  }
}
